import { AiChatPage } from '../types';

type PathRegex = {
  re: RegExp;
  pages: AiChatPage[];
  constructPath: (id: string) => string;
};

const PATH_REGEXES: PathRegex[] = [
  {
    re: /^\/studies\/(\d+)/,
    pages: ['study'],
    constructPath: (id: string) => `/studies/${id}`
  },
  {
    re: /^\/sessions\/(\w+)/,
    pages: ['interview', 'unmoderated_test'],
    constructPath: (id: string) => `/sessions/${id}`
  }
];

export function getContextObjFromUrl(url: string, scopes?: AiChatContext[] | undefined): AiChatContext | null {
  for (const { re, pages } of PATH_REGEXES) {
    const match = url.match(re);
    if (match) {
      const id = match[1];
      // Try to find a scope with this ID for each page type
      for (const pageType of pages) {
        const scopeMatch = scopeLookup({ id, context_type: pageType }, scopes);
        if (scopeMatch) {
          return scopeMatch;
        }
      }
      // If no scope match found, return a guessed context
      return { id, context_type: pages[0] };
    }
  }
  return null;
}

export function getUrlFromContextObj(context: AiChatContext): string | null {
  const pathRegex = PATH_REGEXES.find(({ pages }) => pages.includes(context.context_type as AiChatPage));
  if (pathRegex) {
    return `${pathRegex.constructPath(context.id)}`;
  }
  return null;
}

export function scopeLookup(context: AiChatContext, scopes: AiChatContext[] | undefined): AiChatContext | null {
  return scopes?.find((scope) => scope.id === context.id && scope.context_type === context.context_type) ?? null;
}

export function isValidScope(context: AiChatContext, scopes: AiChatContext[] | undefined): boolean {
  return scopeLookup(context, scopes) ? true : false;
}
